export function setItem(windowObj: Window, key: string, value: string): void {
    if (windowObj.localStorage != null) {
        try {
            windowObj.localStorage.setItem(key, value);
        } catch (e) {
            // suppress quota exception
        }
    }
}

export function getItem(windowObj: Window, key: string): string {
    if (windowObj.localStorage != null) {
        return windowObj.localStorage.getItem(key);
    } else {
        return null;
    }
}

export function removeItem(windowObj: Window, key: string): void {
    if (windowObj.localStorage != null) {
        return windowObj.localStorage.removeItem(key);
    }
}
